var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotNetSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.6,
    height: 16.6,
    viewBox: "0 0 16.6 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5c2d91",
    cx: 8.186,
    cy: 8.186,
    rx: 8.186,
    ry: 8.186,
    transform: "translate(0.228 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "M1.848,9A8.186,8.186,0,1,0,13.406,20.558Z",
    transform: "translate(0.892 -6.698)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.351,35.129a.345.345,0,0,1-.256-.107.353.353,0,0,1-.1-.256.358.358,0,0,1,.1-.256.343.343,0,0,1,.256-.11.35.35,0,0,1,.256.11.356.356,0,0,1,.107.256.367.367,0,0,1-.363.363Z",
    transform: "translate(-4.23 -25.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.345,23.433h-.67l-2.4-3.719a1.535,1.535,0,0,1-.148-.292h-.02a4.789,4.789,0,0,1,.026.64v3.372H12.59V18.77H13.3l2.333,3.653q.146.228.189.312h.013a4.932,4.932,0,0,1-.033-.686V18.77h.545Z",
    transform: "translate(-9.141 -13.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.479,23.433H32V18.77h2.364v.494H32.558v1.55h1.683v.491H32.558v1.617h1.924Z",
    transform: "translate(-23.586 -13.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.571,19.264H45.215v4.17H44.67v-4.17H43.33V18.77h3.241Z",
    transform: "translate(-32.018 -13.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M21.451,43.325a1.261,1.261,0,0,1-.593.125.957.957,0,0,1-.734-.294,1.09,1.09,0,0,1-.276-.767,1.141,1.141,0,0,1,.31-.834,1.054,1.054,0,0,1,.788-.317,1.261,1.261,0,0,1,.512.09v.256a1.023,1.023,0,0,0-.512-.128.783.783,0,0,0-.6.256.931.931,0,0,0-.23.66.888.888,0,0,0,.215.627.732.732,0,0,0,.565.233,1.059,1.059,0,0,0,.56-.143Z",
    transform: "translate(-14.541 -30.688)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M28.033,45.176a.711.711,0,0,1-.545-.228.8.8,0,0,1-.2-.57.829.829,0,0,1,.212-.6.767.767,0,0,1,.57-.217.688.688,0,0,1,.535.212.839.839,0,0,1,.192.586.824.824,0,0,1-.207.588A.726.726,0,0,1,28.033,45.176Zm.018-1.4a.468.468,0,0,0-.373.161.663.663,0,0,0-.138.445.627.627,0,0,0,.138.43.473.473,0,0,0,.373.159.45.45,0,0,0,.366-.153.67.67,0,0,0,.128-.44.68.68,0,0,0-.128-.443A.448.448,0,0,0,28.051,43.777Z",
    transform: "translate(-20.077 -32.414)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M35.523,43.923a.3.3,0,0,0-.187-.049.315.315,0,0,0-.256.148.686.686,0,0,0-.1.4v.783H34.72V43.674h.256v.32h0a.537.537,0,0,1,.161-.256.366.366,0,0,1,.24-.09.4.4,0,0,1,.146.02Z",
    transform: "translate(-25.61 -32.483)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M39.8,44.467H38.719a.573.573,0,0,0,.13.394.476.476,0,0,0,.363.138.767.767,0,0,0,.476-.171v.23a.89.89,0,0,1-.535.146.65.65,0,0,1-.512-.21.857.857,0,0,1-.187-.588.839.839,0,0,1,.2-.583.652.652,0,0,1,.512-.225.578.578,0,0,1,.466.194.814.814,0,0,1,.164.542Zm-.256-.207a.512.512,0,0,0-.1-.33.35.35,0,0,0-.281-.118.4.4,0,0,0-.294.125.565.565,0,0,0-.151.325Z",
    transform: "translate(-28.389 -32.444)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNetSm);
export default __webpack_public_path__ + "static/media/dotNet-sm.471fc3c4cbc6031e9055daa74638c248.svg";
export { ForwardRef as ReactComponent };